import React, { useContext, useEffect, useRef, useState } from 'react';
import { RECOMMENDED_CONSTANTS } from '../Constants/RecommendedComponentConstant';
import { useDispatch, useSelector } from 'react-redux';
import SampleArrowNext from './SampleArrowNext';
import SampleArrowPrev from './SampleArrowPrev';
import MenuCard from 'organisms/MenusPLP/Presentation/MenuCard';
import {
  fetchItemDetailsAction,
  addItemToFavouriteAction,
  addItemToUnFavouriteAction,
} from '@kfc-global/react-shared/redux/Actions/MenuAction';
import {
  addItemToCartAction,
  setUserLastActiveTime,
  showCustomizationModalAction,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import { UserOrderContext } from 'context/context';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import {
  getAndCheck,
  getToOpenMiniPDPModal,
  getValueOrDefaultArray,
  getValueOrDefaultObject,
  isEmptyEvery,
  isMobileDevice,
} from 'common/utilities/utils';
import { ChannelManager } from 'common/manager';
import {
  PICK_UP,
  DINE_IN,
  DELIVERY,
  DELIVERY_TEXT,
  DINE_IN_TEXT,
  mockObject,
  mockArray,
} from 'common/constants/SharedConstants';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/Constants/MenuPDPPageConstants';
import { useLocation } from 'react-router-dom';
import UpsellCrossell from 'molecules/UpsellCrossell/Presentation/UpsellCrossell';
import { setPrevArrowCSS } from 'organisms/CartPage/Presentation/ReusableComponents/IndulgentAddOn';
import { MakeItAComboClick } from 'organisms/MenuPDPPage/Presentation/ReusableComponents/PdpAnalytics';
import FoodItemListHandlers from 'organisms/CartPage/Presentation/ReusableComponents/FoodItemListHandlers';
const {
  PDP_RECOMMENDATIONS,
  CAROUSAL_CONFIG,
  SLIDES_TO_SCROLL_MOBILE,
  BREAKPOINT,
  CONTENT_DATA_MAX_LENGTH_TO_SCROLL,
  FADE_CARD_INDEX,
} = RECOMMENDED_CONSTANTS;
const { ADD_TO_CART_CLICK, MINI_PDP_DATA, FROMFLAGPLP, EDIT_CLICKED, PDP_URL } = START_ORDER_CONSTANTS;
const { RESET_MODGROUP_IDS_UPDATE, UPSELL, PDP } = MENU_PDP_PAGE_CONSTANTS;
const { SPEED, SLIDES_TO_SHOW, SLIDES_TO_SCROLL } = CAROUSAL_CONFIG;
const { PDP_SLIDES_TO_SHOW, PDP_CONTENT_DATA_MAX_LENGTH_TO_SCROLL } = PDP_RECOMMENDATIONS;

export const serviceType = disposition => {
  let type = PICK_UP;
  if (disposition === DELIVERY_TEXT) {
    type = DELIVERY;
  }
  if (disposition === DINE_IN_TEXT) {
    type = DINE_IN;
  }
  return type;
};

export const cardsClass = (i, cSlide) => {
  let dClass = 'recommended-card';
  if (i === cSlide + FADE_CARD_INDEX) {
    dClass += ' recommendedCard-fade';
  }
  return dClass;
};

export const checkCarauselConfigurations = cssClass => {
  const maxLengthToScroll =
    cssClass === 'pdp-recommendations' || cssClass === 'pdp-combo'
      ? PDP_CONTENT_DATA_MAX_LENGTH_TO_SCROLL
      : CONTENT_DATA_MAX_LENGTH_TO_SCROLL;
  const slidesToShow =
    cssClass === 'pdp-recommendations' || cssClass === 'pdp-combo' ? PDP_SLIDES_TO_SHOW : SLIDES_TO_SHOW;
  return { maxLengthToScroll, slidesToShow };
};

const RecommendedItem = props => {
  const { products, storeClosedData, header = '', subHeader = '', cssClass = '', recommendedRule, source = '' } = props;
  const [rangeValue, updateRangeValue] = useState(0);
  const [currentSlide, updateCurrentSlide] = useState(0);
  const carousal = useRef(null);
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const dispatch = useDispatch();
  const { maxLengthToScroll, slidesToShow } = checkCarauselConfigurations(cssClass);
  const { dispositionStateData = mockObject } = userOrderState;
  const { dispositionType = localStorage.getItem('dispositionType') } = dispositionStateData;
  const [flagUpsellCrossell, setFlagUpsellCrossell] = useState();
  const { tenantReducer, cartReducer, userParams, menuReducer } = useSelector(data => {
    return {
      tenantReducer: getValueOrDefaultObject(data.tenantReducer),
      cartReducer: getValueOrDefaultObject(data.cartReducer),
      userParams: getValueOrDefaultObject(data.appStateReducer.userStatus),
      menuReducer: getValueOrDefaultObject(data.menuReducer),
    };
  });
  const { flatResponse = {} } = menuReducer;
  const { showProductListingModal = false } = getValueOrDefaultObject(cartReducer);
  const location = useLocation();
  const { PlpProductCard = mockObject } = tenantReducer?.componentOptions || mockObject;
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;
  const storeInfo = dispositionNew ? dispositionNew.store : mockObject;
  const catalogs =
    (storeInfo?.summary?.menu?.catalogs?.length && storeInfo?.summary?.menu?.catalogs[0]) ||
    tenantReducer?.genericMenuName ||
    '';

  // Removing hidden products for the recommendations list
  const noHiddens = products?.filter(i => !i.isHidden);

  const productList =
    source === PDP
      ? noHiddens
      : noHiddens?.filter(i => {
          let channel = ChannelManager.channel;
          let type = serviceType(dispositionType);
          return i.channel === channel && i.service === type;
        });

  const { showCartAlert } = FoodItemListHandlers(
    undefined,
    undefined,
    undefined,
    undefined,
    userOrderStateDispatch,
    dispatch,
    undefined,
  );

  //modal open for multiple customization
  const openAlertModal = () => {
    showCartAlert(true);
  };

  const carouselDefaults = {
    dots: false,
    infinite: false,
    speed: SPEED,
    slidesToShow: slidesToShow,
    slidesToScroll: SLIDES_TO_SCROLL,
    arrows: true,
    adaptiveHeight: false,
    autoplay: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: BREAKPOINT,
        settings: {
          slidesToShow: SLIDES_TO_SCROLL_MOBILE,
          arrows: true,
          swipeToSlide: true,
        },
      },
    ],
  };

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setIsMobile(isMobileView);
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  const onNextCard = () => {
    if (currentSlide < productList.length - 1) {
      let updatedCurrentSlide = 0;
      if (currentSlide + SLIDES_TO_SCROLL > productList.length - slidesToShow - 1) {
        updatedCurrentSlide = productList.length - slidesToShow;
      } else {
        updatedCurrentSlide = currentSlide + SLIDES_TO_SCROLL;
      }
      setPrevArrowCSS(updatedCurrentSlide);
      updateCurrentSlide(updatedCurrentSlide);
      carousal.current.slickGoTo(updatedCurrentSlide);
    }
  };

  const onPrevCard = () => {
    if (currentSlide > 0) {
      updateCurrentSlide(currentSlide - SLIDES_TO_SCROLL);
      carousal.current.slickGoTo(currentSlide - SLIDES_TO_SCROLL);
    }
    setPrevArrowCSS(currentSlide - SLIDES_TO_SCROLL);
  };

  const onUpdateRange = e => {
    updateRangeValue(e.target.value);
    carousal.current.slickGoTo(e.target.value);
    setPrevArrowCSS(e.target.value);
  };

  const settings = {
    ...carouselDefaults,
    nextArrow: <SampleArrowNext clickNextCard={onNextCard} />,
    prevArrow: <SampleArrowPrev clickPrevCard={onPrevCard} />,
    beforeChange: (current, next) => updateRangeValue(next),
    afterChange: (current, prev) => updateCurrentSlide(current),
  };

  const clickHandler = (e, customizable, categoryDetails, productDetailsData) => {
    const { id, product } = productDetailsData;
    const catId = id?.split('_')[0] || '';
    const { categoryId: productCatId = '' } = flatResponse?.productMapById?.[catId] ?? {};
    const {
      id: categoryId = '',
      name: categoryName = '',
      url: categoryUrl = '',
    } = flatResponse?.categoryMapById?.[productCatId] ?? {};
    // analytics method
    recommendedRule === UPSELL && MakeItAComboClick();
    e && e.stopPropagation();
    if (userParams.localized) {
      if (customizable) {
        setFlagUpsellCrossell(recommendedRule);
        userOrderStateDispatch({
          type: MINI_PDP_DATA,
          value: { id: id, flag: FROMFLAGPLP, foodLineId: '' },
        });
        userOrderStateDispatch({ type: RESET_MODGROUP_IDS_UPDATE });
        userOrderStateDispatch({
          type: EDIT_CLICKED,
          value: { cartEditClicked: true },
        });
        dispatch(
          fetchItemDetailsAction({
            tenantId: tenantReducer.tenantId,
            catalogName: catalogs,
            itemId: id,
          }),
        );
      } else {
        dispatch(
          addItemToCartAction(
            {
              params: {
                basketId: cartReducer?.cartData?.id,
              },
              tenantId: tenantReducer.tenantId,
            },
            [
              {
                Id: id,
                categoryId: categoryId,
                quantity: 1,
                modGrps: mockArray,
                categoryName: categoryName,
                categoryUrl: categoryUrl,
              },
            ],
          ),
        );
        dispatch(setUserLastActiveTime(new Date()));
      }
    } else {
      userOrderStateDispatch({
        type: ADD_TO_CART_CLICK,
        value: {
          addToCart: true,
          productItemId: id,
          categoryId: categoryId,
          oldProduct: product,
          customizable: customizable,
          catalogs: catalogs,
          fromPdpPage: false,
        },
      });
    }
  };
  const currentItemDetailsMiniPDP = useSelector(({ menuReducer }) => menuReducer?.currentItemDetails);
  useEffect(() => {
    let toOpen = getToOpenMiniPDPModal(currentItemDetailsMiniPDP, userOrderState);
    if (getAndCheck(toOpen, flagUpsellCrossell === recommendedRule)) {
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: true,
          categorySelected: '',
        }),
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItemDetailsMiniPDP, userOrderState.minipdpData.itemId, userOrderState.cartEditClicked]);

  useEffect(() => {
    if (showProductListingModal) {
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: false,
          categorySelected: '',
        }),
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const addItemToFavourite = (tenantId, data, customerId) => {
    dispatch(
      addItemToFavouriteAction(
        {
          tenantId,
          customerId,
        },
        data,
      ),
    );
  };

  const removeItemFromFavourite = (tenantId, customerId, itemId) => {
    dispatch(
      addItemToUnFavouriteAction({
        tenantId,
        customerId,
        itemId,
      }),
    );
  };

  const cardRenderer = () =>
    productList.map((item, index) => {
      const poprts = getValueOrDefaultArray(item.additionalProperties);
      const additionalProperties =
        poprts.length &&
        poprts.reduce(
          (acc, { key, value }) =>
            (acc = {
              ...acc,
              [key]: value === 'True' ? true : value === 'False' ? false : value,
            }),
          mockObject,
        );
      return (
        <div className={cardsClass(index, currentSlide)}>
          <MenuCard
            key={item.id}
            item={item}
            cardId={item.id}
            cardType={'medium'}
            cardFor={'recommended'}
            configureOptions={PlpProductCard}
            tenantData={tenantReducer}
            servingCount={additionalProperties?.servings}
            button={item.button}
            categoryId={''}
            clickHandler={clickHandler}
            customizable={item.customizable}
            onCardClickHandler={() => {}}
            userParams={userParams}
            storeClosedData={storeClosedData}
            addFavourite={addItemToFavourite}
            removeFavourite={removeItemFromFavourite}
            data-testid='menu-card-component'
            openAlertModal={openAlertModal}
            {...additionalProperties}
            {...item}
          />
        </div>
      );
    });

  return (
    Boolean(productList?.length) && (
      <UpsellCrossell
        cardRenderer={cardRenderer}
        productList={[...productList]}
        carousal={carousal}
        header={header}
        subHeader={subHeader}
        settings={settings}
        maxLengthToScroll={maxLengthToScroll}
        slidesToShow={slidesToShow}
        rangeValue={rangeValue}
        onUpdateRange={onUpdateRange}
        showProductListingModal={showProductListingModal}
        isMobile={isMobile}
        flagUpsellCrossell={flagUpsellCrossell}
        {...props}
      />
    )
  );
};

export default RecommendedItem;
